import dayjs from "dayjs"
import { useContext } from "react"
import { SidePanelContext } from "../../../../components/contexts/SidePanelContext"
import HeadTableRow from "../HeadTableRow"
import { returnAddressString } from "../../../../services/functions"
import { Tag } from "antd"
import { MailReportType } from "../../../../data/Types"
import { ReactComponent as EYE } from "../../../../assets/EyeICON.svg"

type OfferDetailHeadType = {
    data: any
    setResendUri: (e: string) => void
    setMailPreviewContent: (e: string) => void
}

export default function OfferDetailHead(props: OfferDetailHeadType) {
    console.log(props.data.mailReports)
    const sidePanelCon = useContext(SidePanelContext)
    return (
        <div className="flex flex-col lg:flex-row gap-4 h-fit">
            {/* Basic Information about Offer */}
            <div className="w-full grow rounded-default shadow-lg mt-6 bg-white p-4 ">
                <HeadTableRow link={"/kunden/" + props.data?.customer_id?._id} info={"Kunde"} content={props.data?.customer_id?.customer?.name} />
                {props.data?.object_id && (
                    <HeadTableRow
                        link={"/objekte/" + props.data?.object_id?._id}
                        info={"Objekt"}
                        content={props.data?.object_id ? returnAddressString(props.data?.object_id?.adress) : "Kein Objekt angegeben"}
                    />
                )}
                <HeadTableRow
                    info={window.innerWidth > 640 ? "ausgestellt am" : "ausgestellt"}
                    content={dayjs(props.data.date).format("DD.MM.YYYY")}
                />
                <HeadTableRow
                    // TODO need real expiry date
                    info={window.innerWidth > 640 ? "läuft ab am" : "läuft ab"}
                    content={dayjs(props.data.date).add(4, "week").format("DD.MM.YYYY")}
                />
                <HeadTableRow info={"Archiviert"} content={props.data?.archived ? "Ja" : "Nein"} />
                <HeadTableRow
                    info={"Rechnung"}
                    content={props.data.created_bill.length > 0 ? "Erstellt" : "Noch Nicht Erstellt"}
                    link={props.data.created_bill.length > 0 ? "/buchhaltung/rechnung/" + props.data.created_bill[0] : ""}
                />
            </div>
            {/* Information about Mail */}
            {props.data.mailReports && props.data.mailReports.length > 0 && (
                <div className="w-full grow bg-white rounded-default shadow-lg lg:mt-6 pt-2 px-4 pb-4 ">
                    <div className="w-full h-8 flex justify-between items-center">
                        <HeadTableRow info={"Absendeversuche"} content={props.data?.mailReports?.length?.toString()} />
                    </div>
                    <div className={`overflow-y-scroll w-full ${props.data.billType !== "Rechnung" ? "h-48" : "h-40"}`}>
                        {props.data.mailReports.map((item: MailReportType) => (
                            <div className="flex flex-col w-full py-1 border-b relative">
                                <HeadTableRow info={"Mail versandt am"} content={dayjs(item.date).format("DD.MM.YYYY, HH:mm") + " Uhr"} />
                                <HeadTableRow
                                    info={"Empfänger"}
                                    content={item.mailReceivers?.map((itemMail: string) => itemMail + (item.mailReceivers?.indexOf(itemMail) + 1 !== item.mailReceivers.length ? ", " : ""))}
                                />
                                <div className="flex flex-wrap pt-1">
                                    {item?.version === 1 ? (
                                        item?.mailDeliverySuccess ? (
                                            <Tag color="green">Erfolgreich</Tag>
                                        ) : (
                                            <Tag color="red">Fehlgeschlagen</Tag>
                                        )
                                    ) : item?.version === 2 ? (
                                        item?.notifuseEvents?.map((event: any) => (
                                            <Tag color={"grey"}>
                                                {event.eventType === "email.sent"
                                                    ? "Versendet"
                                                    : event.eventType === "email.clicked"
                                                    ? "Angeklickt"
                                                    : event.eventType === "email.opened"
                                                    ? "Geöffnet"
                                                    : ""}
                                            </Tag>
                                        ))
                                    ) : undefined}
                                </div>
                                <EYE
                                    aria-disabled={!item.mailContent}
                                    className="hidden sm:block btn btn-outline btn-primary btn-xs absolute top-2 right-4"
                                    onClick={() => {
                                        props.setResendUri(item.resendUri)
                                        props.setMailPreviewContent(item.mailContent)
                                        sidePanelCon?.trigger(4)
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}
